import { createDefaultNativeStackNavigator } from 'app/lib/navigation';
import { GroupMembersScreen } from 'app/screens/groups/group-members-screen';
import { AllNotificationsScreen } from 'app/screens/notifications/all-notifications';
import type { FindAllUsersDTO } from 'app/types/user';

export type Parameters = {
  'all-notifications': undefined;
  'group-members': FindAllUsersDTO;
};

export { linking } from './navigator.linking';

const Stack = createDefaultNativeStackNavigator<Parameters>();

export function Navigator() {
  return (
    <Stack.Navigator initialRouteName="all-notifications" screenOptions={{ cardStyle: { backgroundColor: 'white' } }}>
      <Stack.Screen component={AllNotificationsScreen} name="all-notifications" />
      <Stack.Screen component={GroupMembersScreen} name="group-members" />
    </Stack.Navigator>
  );
}
